import * as S from "../../Style/Page/Car.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleCar.js";
import HatPageTopLine from "../../Component/CarPageTopLine.js";
import CarImg from "../../assets/car/16. 버스사업소개 버스3.png";
import MapImg from "../../assets/car/17. 버스사업 글로벌지도.png";
const CarBusinessHistory = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"상용버스사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/BusBusiness/OverseasBus">
                <div className="kor">버스사업</div>
                <div className="eng">Bus Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">ForkLift Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"156px"}>
            <S.NavItem>
              <Link to="/BusBusiness/OverseasBus">
                <div className="kor">해외 상용버스사업</div>
                <div className="eng">Overseas commercial bus business</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">해외 상용버스사업</div>
                  <div className="eng">Overseas commercial bus business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory">
                  <div className="kor">생산공장</div>
                  <div className="eng">production plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/BusBusinessHistory">
                  <div className="kor">버스사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle titleko={"사업개요"} titleeng={"Business Briefs"} />
            <div className="page-text">
              <div className="kor">
                자일대우버스의 역사는 1955년 "신진공업사"로 버스 제조업을
                시작하였습니다. 1966년 새나라 자동차를 인수하여
                "신진자동차공업"으로,1972년에는 GM과 합작하여 GM KOREA로,
                1976년에 새한자동차로 상호를 변경 하였고, 2002년에는
                대우자동차㈜에서 회사를 분리하여 대우버스주식회사로
                출범하였습니다. 영안모자는 1995년 코스타리카의 마우코사를
                인수하며 버스사업에 최초 진출하고 이후 2003년 5월, 한국
                대우버스(주)를 인수하였습니다. 이후 2003년 중국 계림 법인 인수,
                2005년 베트남 법인 신규설립, 2007년 카자흐스탄 합자법인 신규
                설립, 2008년 파키스탄 합자법인 신규설립, 2018년 미얀마 합자법인
                신규설립, 2019년 베트남 부품공장 합자법인을 신규 설립하여
                버스사업 글로벌 경영 체계를 완성 시켰습니다. 자일대우버스는 연간
                7천대 이상(완성차 및 KD)의 생산 능력을 갖춘 울산공장을 통해 국내
                시장에 시내버스와 고급형 버스 등을 생산 공급해 왔으나, 2022년
                7월 부터는 국내 공장 생산을 중단하고 법인 청산 절차를 진행하고
                있습니다. 현재는 오랜 노하우를 가진 글로벌 경영방식으로 해외의
                생산 공장 4곳, 부품공장 2곳, 판매법인 1곳을 통한 버스사업을 진행
                중입니다.
              </div>
              <div className="eng">
                Zyle Daewoo Bus started manufacturing buses in 1955 named as
                “Shinjin Industry Co..” In 1966, it took over Saenara Motors and
                changed its name as "Shinjin Motors Industry", and in 1972, it
                made a joint venture with GM and changed its name as GM Korea.{" "}
                <br />
                In 1976, GM Korea changed its name as Saehan Motors, after then
                its name was changed as Daewoo Motors Co.. Daewoo Bus Corp.
                separated and newly started from Daewoo Motors Co. in 2002.{" "}
                <br />
                Since YoungAn Hat Co. entered into the bus business for the
                first time by acquiring Mauco in Costa Rica in 1995, it took
                over Daewoo Bus Corp. in Korea in May 2003. <br />
                After then, it has completed global business net-works through
                acquiring of Guilin Daewoo Bus in China in 2003 and
                establishment of Vietnam Daewoo Bus in 2005. Daewoo Bus
                Kazakhstan in 2007, Daewoo PAK Motors in Pakistan in 2008,
                Daewoo Bus Myanmar in 2018 and Automotive Parts Joint-Venture in
                Vietnam in 2019. <br />
                Zyle Daewoo Bus had supplied city buses and luxury buses in
                domestic market through the Ulsan Plant, which has a production
                capacity of more than 7,000 units (CBU and KD). However, it has
                stopped production at Ulsan plants from July 2022 and has been
                under liquidation procedures. <br />
                Now, we are carrying out our global bus business with five
                overseas production plants based on using our global management
                know-how filed long-time.
              </div>
            </div>
            <PageTitle titleko={"사업장 현황"} titleeng={"Business Status"} />

            <div className="page-text">
              <div className="kor">
                생산공장 4곳 (베트남 / 중국 계림 / 파키스탄 / 카자흐스탄)
                <br />
                부품공장 2곳 (베트남)
                <br />
                판매법인 1곳 (코스타리카)
              </div>
              <div className="eng">
                Production facilities: 4 (Vietnam, China (Guilin), Pakistan,
                Kazakhstan
                <br />
                Component factories : 2 (Vietnam)
                <br />
                Sales corporation: 1 (Costa Rica)
              </div>
              <img src={CarImg} alt="" className="hat-img" />
            </div>

            <img src={MapImg} alt="" className="fullsize-map" />
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default CarBusinessHistory;
